import Formsy from 'formsy-react'
import { withTranslate } from 'i18n/utils'
import Select from '@components/Select/RequiredSelectWithFormsy'
import FormsyInput from '@components/Textfield/withFormsy'
import Button from '@components/Button'
import ErrorMessage from '@components/ErrorMessage'
import isMobile from 'shared/responsive-helpers'
import { getYearsSelection, getMonthsSelection } from 'credit-cards/utils'

import styles from 'credit-cards/pagseguro/components/styles.module.scss'

const CreditCardForm = ({
    submit,
    formRef,
    translate: t,
    creditCardInputHelper,
    zip,
    isLoading,
    error,
    buttonClassName,
    handleSubmit,
    isInvisible,
    handleKeyDown,
}) => (
    <Formsy onSubmit={submit} ref={formRef} onSubmitCapture={handleSubmit} className={isInvisible && 'invisible'}>
        <FormsyInput
            placeholder={t('pagseguro.creditcard.cardholders-name.label')}
            name="cardholdersName"
            validations={{ matchRegexp: /^\S+(?:\s+\S+)+$/, isSpecialWords: true, maxLength: 40 }}
            validationError={t('pagseguro.creditcard.cardholders-name.error')}
            required
            avoidErrorOnReset
            value=""
        />
        <FormsyInput
            placeholder={t('pagseguro.creditcard.cardnumber.label')}
            name="cardNumber"
            type={isMobile() ? 'tel' : 'text'}
            onKeyDown={handleKeyDown}
            validations={{ matchRegexp: /^[0-9]/, minLength: 12, maxLength: 23 }}
            validationError={t('pagseguro.creditcard.cardnumber.error')}
            valueModifier={!isMobile() && creditCardInputHelper} // don't use on mobile, because some android + chrome can handle it
            required
            value=""
            avoidErrorOnReset
        />
        <div className="d-flex justify-content-between">
            <div className="d-flex col px-0">
                <div className={styles.monthInput}>
                    <Select
                        placeholder={t('pagseguro.creditcard.expiry-month.label')}
                        name="expiryMonth"
                        options={getMonthsSelection()}
                        getSelectValue={v => getMonthsSelection().find(c => c.value === v) || ''}
                        required
                        value=""
                    />
                </div>
                <div className={styles.yearInput}>
                    <Select
                        placeholder={t('pagseguro.creditcard.expiry-year.label')}
                        name="expiryYear"
                        options={getYearsSelection()}
                        getSelectValue={v => getYearsSelection().find(c => c.value === v) || ''}
                        required
                        value=""
                    />
                </div>
            </div>
            <FormsyInput
                className={styles.ccv}
                placeholder={t('pagseguro.creditcard.ccv.label')}
                name="ccv"
                validations={{ isNumeric: true, minLength: 3 }}
                validationError={t('pagseguro.creditcard.ccv.error')}
                required
                value=""
                avoidErrorOnReset
            />
        </div>
        {!zip && (
            <FormsyInput
                className={styles.zip}
                placeholder={t('pagseguro.creditcard.zip-code.label')}
                name="zipCode"
                validations={{ isAlphanumeric: true }}
                validationError={t('pagseguro.creditcard.zip-code.error')}
                required
                value=""
                avoidErrorOnReset
            />
        )}
        <Button type="submit" isLoading={isLoading} disabled={isLoading} className={buttonClassName}>
            {t('pagseguro.creditcard.submit.label')}
        </Button>
        {error && <ErrorMessage messages={[error]} className="mt-3" />}
    </Formsy>
)

export default withTranslate(CreditCardForm)
